import { hasWindow } from "@rpldy/shared";
export const GLOBAL_VERSION_SYM = Symbol.for("_rpldy-version_");
const getVersion = () => "1.7.1" || "";
const getGlobal = () => /* istanbul ignore next */
// $FlowIgnore
hasWindow() ? window : globalThis || process;
const getRegisteredVersion = () => {
  return getGlobal()[GLOBAL_VERSION_SYM];
};
const registerUploadyContextVersion = () => {
  getGlobal()[GLOBAL_VERSION_SYM] = getVersion();
};
const getIsVersionRegisteredAndDifferent = () => {
  const registeredVersion = getRegisteredVersion();
  return !!registeredVersion && registeredVersion !== getVersion();
};
export { getVersion, getRegisteredVersion, registerUploadyContextVersion, getIsVersionRegisteredAndDifferent };